"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarEventStatus = void 0;
var CalendarEventStatus;
exports.CalendarEventStatus = CalendarEventStatus;

(function (CalendarEventStatus) {
  CalendarEventStatus["AS_NEEDED"] = "asNeeded";
  CalendarEventStatus["COMPLETE"] = "complete";
  CalendarEventStatus["INCOMPLETE"] = "incomplete";
  CalendarEventStatus["NOT_NEEDED"] = "notNeeded";
  CalendarEventStatus["EXTRA"] = "extra";
  CalendarEventStatus["OVERDUE"] = "overdue";
  CalendarEventStatus["UPCOMING"] = "upcoming";
  CalendarEventStatus["DELETED"] = "deleted";
})(CalendarEventStatus || (exports.CalendarEventStatus = CalendarEventStatus = {}));